// extracted by mini-css-extract-plugin
export var downArrow = "_a1-0";
export var label = "_a1-1";
export var treatmentCard = "_a1-3";
export var upArrow = "_a1-2";